/**
 * How a run is named in a URL. A fan-out child's run id holds slashes, which the server's firewall refuses when
 * encoded, so such an id travels as `~r~` plus its base64url (PROPOSAL-ol-25-fan-out-run-view.md). Every /v1/runs/{id}
 * call and every /cases/{id} link goes through here, so a page reload never carries an encoded slash either.
 */
const PREFIX = '~r~';

export function runPathId(runId: string): string {
  if (!runId.includes('/')) return encodeURIComponent(runId);
  const bytes = new TextEncoder().encode(runId);
  const b64 = btoa(String.fromCharCode(...bytes));
  return PREFIX + b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/** The real run id from a /cases/{id} route parameter. Something not a token is left as it is, for the server to refuse. */
export function runIdFromPath(param: string): string {
  if (!param.startsWith(PREFIX)) return param;
  try {
    const bin = atob(param.slice(PREFIX.length).replace(/-/g, '+').replace(/_/g, '/'));
    const decoded = new TextDecoder().decode(Uint8Array.from(bin, (c) => c.charCodeAt(0)));
    return runPathId(decoded) === param ? decoded : param;
  } catch {
    return param;
  }
}

/** The console route for a case. */
export function casePath(runId: string, entityId?: string | null): string {
  return `/cases/${runPathId(runId)}${entityId ? `?entity=${encodeURIComponent(entityId)}` : ''}`;
}
